import { DELEGATION_STATES } from 'common/domain/constants';

class ModalDelegationManagerController {

  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.state = '';
    this.modalTitle = '';
    this.modalMessage = '';
  }

  isCreating() {
    return this.state === DELEGATION_STATES.CREATE;
  }

  isEditing() {
    return this.state === DELEGATION_STATES.EDIT;
  }

  isDeleting() {
    return this.state === DELEGATION_STATES.CANCEL;
  }

  isSuccess() {
    return this.state === DELEGATION_STATES.SUCCESS;
  }

  isError() {
    return this.state === DELEGATION_STATES.ERROR;
  }

  onDismiss() {
    this.modalClose();
  }
}

export default ModalDelegationManagerController;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalDelegationManager.controller.js